<ion-header>
  <ion-toolbar class="auth-account-toolbar">
    <ion-title>
      <ion-text> TEMPORARY SCREEN !!!! ONLY FOR TESTING</ion-text>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="auth-account-screen-container">
    <h3 class="title-main">Choose account type</h3>

    <ion-list>
      <ion-radio-group
        [(ngModel)]="accountType"
        (ionChange)="handleChangeType($event)"
      >
        <ion-list-header>
          <ion-label>Account Type</ion-label>
        </ion-list-header>

        <ion-item>
          <ion-label>Resource</ion-label>
          <ion-radio
            slot="start"
            value="resource"
            checked="accountType === 'resource'"
          ></ion-radio>
        </ion-item>

        <ion-item>
          <ion-label>Supervising Resource</ion-label>
          <ion-radio
            slot="start"
            value="supervising-resource"
            checked="accountType === 'supervising-resource'"
          ></ion-radio>
        </ion-item>

        <ion-item>
          <ion-label>Venue Manager</ion-label>
          <ion-radio
            slot="start"
            value="venue-manager"
            checked="accountType === 'venue-manager'"
          ></ion-radio>
        </ion-item>
      </ion-radio-group>
    </ion-list>

    <div class="btn-group-container">
      <ion-button expand="block" color="primary" (click)="handleApply($event)"
        >Apply</ion-button
      >
    </div>
  </div>
</ion-content>
